/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @stylistic/max-len */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @stylistic/no-mixed-operators */
import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import { Container, Row, Col, OverlayTrigger, Tooltip, Accordion } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle, faInfoCircle, faXmark, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faAlarmClock } from '@fortawesome/pro-solid-svg-icons';
import { toast } from 'react-toastify';

import DiscountReasonModal from '../../Modals/DiscountReasonModal';
import TextArea from '../../Parts/TextArea';
import Money from '../../Parts/Money';
import apiCalls from '../../PowerShadesAPIFunctions';
import { UsePortalDispatch } from '../../Store';
import Button from '../../Parts/Button';
import { captureSentryError, isFailedApiCall } from '../../psUtil';
import { UseMultipliersByQuoteId, useQuoteById, useQuotePricing, useQuoteTypeNameByQuoteId } from '../../Store/entities/quotes/hooks';
import { useCurrentMultiplier } from '../../Store/entities/multipliers/hooks';
import { loadDemoReview, useQuoteDemoReview } from '../../Store/entities/quoteDemoReviews/hooks';
import { useIsPsAdmin } from '../../hooks';

interface DemoReviewProps {
	demoReviewFailed?: boolean;
	placeOrderButton?: React.ReactNode;
	quoteId: number;
}

interface DemoReviewState {
	confirmOpen: boolean;
	mainOpen: boolean;
	reviewType: string;
	buttonText: string;
	rejectionReason: string;
	inputValue: number;
	previousDemoQuotes: { demo_quotes: any[] }; // TODO: Replace with proper type
	freeShipping: boolean;
	errorOpen: boolean;
	errorMessage: string;
	submitting: boolean;
	requestingReview: boolean;
	showDiscountModal: boolean;
}

const DemoReview: React.FC<DemoReviewProps> = ({
	demoReviewFailed = false,
	placeOrderButton,
	quoteId
}) => {
	const { multiplier } = useCurrentMultiplier(quoteId);
	const isPsAdmin = useIsPsAdmin();

	const discountAmount = (0.6 - (1 - multiplier)) / multiplier;

	const quoteMultipliers = UseMultipliersByQuoteId(quoteId);

	const myPriceMultiplier = quoteMultipliers?.list?.find((m) => m.name === 'My Price') ?? quoteMultipliers?.list?.find((m) => m.name === 'Dealer Price');

	const quotePricing = useQuotePricing(quoteId, myPriceMultiplier?.multiplier ?? 1, myPriceMultiplier?.currency_multiplier ?? 1);
	const totalPricing = useQuotePricing(quoteId, 1, myPriceMultiplier?.currency_multiplier ?? 1);

	const demoInfo = useQuoteDemoReview(quoteId);
	const dispatch = UsePortalDispatch();

	const quoteIdNumForced = Number(quoteId);
	console.log('DemoReview quoteId:', quoteIdNumForced);
	const quote = useQuoteById(quoteIdNumForced);

	const isOrder = quote?.order_status !== 'active_quote';

	const demoRequestedTime = demoInfo?.demo_requested_time ?? Date.now() / 1000;

	const [state, setState] = useState<DemoReviewState>({
		confirmOpen: false,
		mainOpen: false,
		reviewType: 'default',
		buttonText: 'Demo Review',
		rejectionReason: '',
		inputValue: discountAmount * 100,
		previousDemoQuotes: { demo_quotes: [] },
		freeShipping: false,
		errorOpen: false,
		errorMessage: 'Operation Failed. If you are receiving this message, please reach out to PowerShades Engineering.',
		submitting: false,
		requestingReview: false,
		showDiscountModal: false,
	});

	const setSubmitting = (bool: boolean) => {
		setState((prev) => ({ ...prev, submitting: bool }));
	};

	const openMain = () => setState((prev) => ({ ...prev, mainOpen: true }));
	const closeMain = () => setState((prev) => ({ ...prev, mainOpen: false }));
	const openConfirm = () => setState((prev) => ({ ...prev, confirmOpen: true }));
	const closeConfirm = () => setState((prev) => ({ ...prev, confirmOpen: false }));
	const openError = () => setState((prev) => ({ ...prev, errorOpen: true }));
	const closeError = () => setState((prev) => ({ ...prev, errorOpen: false }));
	const setError = (message: string) => setState((prev) => ({ ...prev, errorMessage: message }));

	const changeShipping = (allowShipping: boolean) => {
		setState((prev) => ({ ...prev, freeShipping: allowShipping }));
	};

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const mainButtonClicked = () => {
		if (demoInfo === null || demoInfo === undefined) {
			openConfirm();
		} else {
			openMain();
		}
	};

	const requestPricing = () => {
		setState((prev) => ({ ...prev, requestingReview: true }));

		apiCalls.requestDemoReview(quoteId).then((resp) => {
			if (isFailedApiCall(resp)) {
				console.error({ resp });
				console.error({ respData: resp?.data });
				console.error({ respError: resp?.error });
				captureSentryError(new Error('Error requesting demo review'));
				toast.error('Error requesting demo review');
				setState((prev) => ({ ...prev, requestingReview: false, mainOpen: true, confirmOpen: false }));
				return;
			}

			dispatch(loadDemoReview(quoteId)).then(() => {
				setState((prev) => ({ ...prev, requestingReview: false, mainOpen: true, confirmOpen: false }));
			});

			toast.success('Demo review requested successfully');
		});
	};

	const setReviewType = (type: string) => {
		const updateObj: Partial<DemoReviewState> = { reviewType: type };

		if (type === 'default') {
			const newDiscountAmount = (0.6 - (1 - multiplier)) / multiplier;
			updateObj.inputValue = newDiscountAmount * 100;
		}

		if (type === 'outdoor') {
			const newDiscountAmount = (0.6 - (1 - multiplier)) / multiplier;
			updateObj.inputValue = newDiscountAmount * 100;
		}

		setState((prev) => ({ ...prev, ...updateObj }));
	};

	const setRejectionReason = (reason: string) => {
		setState((prev) => ({ ...prev, rejectionReason: reason }));
	};

	const setInputValue = (value: number) => {
		setState((prev) => ({ ...prev, inputValue: value }));
	};

	const submitApproval = (reason: string) => {
		setSubmitting(true);
		const { reviewType, inputValue, freeShipping, rejectionReason } = state;

		const approvalTypes = {
			CASH_OVERRIDE: 'cash',
			PERCENTAGE_DECREASE: 'percentage',
			REJECT_DEMO: 'reject',
		};

		const handleApiResponse = (resp: any) => {
			console.log('API response:', resp);
			if (isFailedApiCall(resp, 'demoReview')) {
				throw new Error('API call failed');
			}
			setSubmitting(false);
			window.location.reload();
		};

		const handleApiError = (error: any) => {
			setSubmitting(false);
			const errorMessage = error.data?.error || error.message || 'An error occurred';
			setError(errorMessage);
			openError();
			console.error({ error });
			captureSentryError(new Error('Error processing demo review'));
			toast.error('Error processing demo review');
		};

		if (reviewType === approvalTypes.REJECT_DEMO) {
			apiCalls
				.rejectDemoReview(quoteId, demoRequestedTime, rejectionReason)
				.then(handleApiResponse)
				.catch(handleApiError);
			return;
		}

		if (reviewType === 'default' || reviewType === 'outdoor') {
			apiCalls
				.approveDemoReview(quoteId, demoRequestedTime, 'percentage', inputValue, freeShipping, reason)
				.then(handleApiResponse)
				.catch(handleApiError);
		} else {
			apiCalls
				.approveDemoReview(quoteId, demoRequestedTime, reviewType, inputValue, freeShipping, reason)
				.then(handleApiResponse)
				.catch(handleApiError);
		}
	};

	const handleDiscountModalCancel = () => {
		setState((prev) => ({ ...prev, showDiscountModal: false }));
	};

	const handleSubmitReviewClick = () => {
		setState((prev) => ({ ...prev, showDiscountModal: true }));
	};

	const handleDiscountModalSubmit = async (_reason: string) => {
		setState((prev) => ({ ...prev, showDiscountModal: false }));
		submitApproval(_reason);
	};

	useEffect(() => {
		const dealerId = quote?.dealer_id;

		if (!dealerId) return;

		if (isPsAdmin) {
			apiCalls.GetDemoOrdersByOrganization(dealerId, 'dealer').then((resp) => {
				if (isFailedApiCall(resp)) {
					throw resp;
				}
				const { data } = resp;
				setState((prev) => ({ ...prev, previousDemoQuotes: { demo_quotes: data.demo_quotes } }));
			}).catch((error) => {
				if (error?.data?.error) {
					setError(error.response.data.message);
				}
				if (error?.error) {
					setError(error.error);
				}
				openError();
				console.error({ error });
				captureSentryError(new Error('Error fetching previous demo quotes'));
				toast.error('Error fetching previous demo quotes');
			});
		}

		return () => {
		};
	}, [quoteId, isPsAdmin]);

	const {
		mainOpen,
		reviewType,
		confirmOpen,
		buttonText,
		rejectionReason,
		inputValue,
		previousDemoQuotes,
		freeShipping,
		errorOpen,
		errorMessage,
		requestingReview,
		submitting,
		showDiscountModal,
	} = state;

	const reviewStatus = demoInfo?.demo_review_status ?? "";

	const approvalTypes = {
		CASH_OVERRIDE: 'cash',
		PERCENTAGE_DECREASE: 'percentage',
		REJECT_DEMO: 'reject',
		DEMO_DEFAULT: 'default',
		OUTDOOR_DEFAULT: 'outdoor',
	};

	const approvalValueNeeded = reviewType === approvalTypes.CASH_OVERRIDE
  || reviewType === approvalTypes.PERCENTAGE_DECREASE;

	const approvalTypeOptions = [
		{ value: approvalTypes.DEMO_DEFAULT, display: 'Default DEMO60' },
		{ value: approvalTypes.OUTDOOR_DEFAULT, display: 'OUTDOOR 60' },
		{ value: approvalTypes.CASH_OVERRIDE, display: 'Cash Override' },
		{ value: approvalTypes.PERCENTAGE_DECREASE, display: 'Percentage Discount' },
		{ value: approvalTypes.REJECT_DEMO, display: 'Reject Demo' },
	];

	const previousMSRP = quotePricing?.subtotal ?? 0;
	const taxRate = (quotePricing?.tax_rate ?? 0) / 100;
	const subtotal = totalPricing?.total_price ?? 0;
	const demoType = demoInfo?.name ?? reviewType;
	const discountValue = demoInfo?.value ?? demoInfo?.value ?? inputValue;
  
	let newMsrp = demoInfo
		? (demoType !== 'cash'
			? subtotal * (1 - discountValue / 100)
			: (demoInfo?.value ?? 0))
		: (approvalTypes.CASH_OVERRIDE === reviewType
			? inputValue
			: approvalTypes.PERCENTAGE_DECREASE === reviewType || approvalTypes.DEMO_DEFAULT === reviewType
				? previousMSRP * (1 - (inputValue / 100))
				: previousMSRP * (1 - 0.2 / 100) || approvalTypes.OUTDOOR_DEFAULT === reviewType
					? previousMSRP * (1 - inputValue / 100)
					: previousMSRP * (1 - 0.2 / 100));

	if (reviewStatus === 'approved') {
		const multipliableMsrp = (totalPricing?.subtotal ?? 0) - (quotePricing?.total_shipping_price ?? 0);
		newMsrp = demoInfo?.name !== 'cash'
			? multipliableMsrp * (1 - (demoInfo?.value ?? 0) / 100)
			: demoInfo.value ?? 0;
		newMsrp += quotePricing?.total_shipping_price ?? 0;
	} else {
		newMsrp += quotePricing?.total_shipping_price ?? 0;
	}

	const newInvoiceTotal = newMsrp * (1 + taxRate);

	const reviewDisplay = {
		pending: 'Pending',
		rejected: 'Rejected',
		approved: 'Approved',
		void: 'Void',
	};

	const reviewStatusDisplay = reviewDisplay[reviewStatus] ?? 'Void';

	const statusDescriptions = {
		pending: 'This demo is pending review from a PowerShades Territory Manager',
		rejected: 'This demo has been rejected by a PowerShades Territory Manager',
		approved: 'This demo has been approved by a PowerShades Territory Manager',
		void: 'Something went wrong trying to load the demo status. Please refresh your page and try again.',
	};

	const prevQuoteRows = previousDemoQuotes?.demo_quotes?.map((pq) => (
		<tr key={pq.timePlaced + pq.quoteId}>
			<td>{pq.quoteId}</td>
			<td>
				{pq.timePlaced !== null
					? new Date(pq.timePlaced * 1000).toLocaleString()
					: 'Not Ordered Yet'}
			</td>
		</tr>
	)) ?? [];

	return (
		<div>
			{!demoReviewFailed ? (
				<>
					<Popup
						key="demo-review-confirm-popup"
						open={confirmOpen}
						onClose={closeConfirm}
						className="mobile-modal"
					>
						<Container fluid>
							<Row className="mt-2">
								<Col>
									<h4 className={`text-${quoteType}`}>Demo Pricing Request</h4>
								</Col>
							</Row>
							<hr />
							<Row className="mb-2">
								<Col>
									I declare that the following is true and correct: This order is for demo
									purposes only and will not be used or re-sold in any form outside the intended
									purpose. Failing to abide by these terms may result in the cancellation of any
									orders and could prohibit future access to PowerShades products and services.
								</Col>
							</Row>
							<hr />
							<Row>
								<Col>
									<Button color="gray" onClick={closeConfirm}>
										Cancel
									</Button>
								</Col>
								<Col className="text-end">
									<Button
										color={quoteType}
										loading={requestingReview}
										onClick={requestPricing}
									>
										Agree and Request Pricing
									</Button>
								</Col>
							</Row>
						</Container>
					</Popup>

					<Popup
						key="demo-review-main-popup"
						open={mainOpen}
						closeOnDocumentClick={false}
						onClose={closeMain}
						className="mobile-modal"
					>
						<Container>
							<Row>
								<Col>
									<h4 className={`text-${quoteType}`}>Demo Review</h4>
								</Col>
								<Col className="text-end">
									<h5>
										<OverlayTrigger
											overlay={
												<Tooltip id="status-check">
													{statusDescriptions[reviewStatus]}
												</Tooltip>
											}
										>
											<Row className="user-select-none">
												<Col className="text-end">{reviewStatusDisplay}</Col>
												<Col xs={2}>
													{reviewStatusDisplay?.toLowerCase()?.includes('pending') && (
														<FontAwesomeIcon
															className={`text-${quoteType}`}
															transform="grow-3"
															icon={faAlarmClock}
														/>
													)}
													{reviewStatusDisplay?.toLowerCase()?.includes('approved') && (
														<FontAwesomeIcon transform="grow-3" icon={faCheck} />
													)}
													{reviewStatusDisplay?.toLowerCase()?.includes('rejected') && (
														<FontAwesomeIcon
															color="red"
															transform="grow-3"
															icon={faXmark}
														/>
													)}
													{reviewStatusDisplay?.toLowerCase()?.includes('void') && (
														<FontAwesomeIcon
															color="yellow"
															transform="grow-3"
															icon={faExclamationTriangle}
														/>
													)}
												</Col>
											</Row>
										</OverlayTrigger>
									</h5>
								</Col>
							</Row>
							<hr />

							<Popup
								nested
								open={errorOpen}
								onClose={closeError}
								contentStyle={{
									width: '40%',
									height: '50%',
								}}
							>
								<h3>Error!</h3>
								<p>{errorMessage}</p>
								<Container
									style={{
										position: 'absolute',
										bottom: 0,
										left: 0,
										width: '100%',
										marginBottom: '1em',
										paddingLeft: '0.5em',
										paddingRight: '0.5em',
									}}
								>
									<Row style={{ display: 'flex' }}>
										<Col style={{ minWidth: '50%' }}>
											<Button color={quoteType} onClick={closeError}>
												Close
											</Button>
										</Col>
									</Row>
								</Container>
							</Popup>

							<Row>
								{!isPsAdmin && reviewStatus?.toLowerCase()?.includes('pending') && (
									<Col xs={12} className="mb-2">
										This demo is pending review from a PowerShades Territory Manager. Please
										check back later.
									</Col>
								)}
								<Col xs={12}>
									{reviewType !== approvalTypes.REJECT_DEMO && (
										<>
											{isPsAdmin && (
												<Row>
													<h6>
														Current Order Cost: (Before Shipping) &nbsp;
														<Money value={previousMSRP} />
													</h6>
												</Row>
											)}
											{reviewStatus?.toLowerCase()?.includes('approved') && (
												<Row>
													<h6>
														Updated Demo Cost: (Before Shipping) &nbsp;
														<Money
															value={
																newInvoiceTotal
                                - (quotePricing?.total_shipping_price ?? 0)
															}
														/>
													</h6>
												</Row>
											)}
											{isPsAdmin && (
												<Row>
													<h6>
														Discount Applied:&nbsp;
														<Money value={newMsrp - previousMSRP} />
													</h6>
												</Row>
											)}
											{reviewStatus?.toLowerCase()?.includes('approved') && (
												<Row>
													<h6>
														Shipping &nbsp;
														<Money value={quotePricing?.total_shipping_price ?? 0} />
													</h6>
												</Row>
											)}
											{reviewStatus?.toLowerCase()?.includes('approved') && (
												<Row>
													<h6>
														Total Demo Cost &nbsp;
														<Money value={newInvoiceTotal} />
													</h6>
												</Row>
											)}
										</>
									)}
									{reviewStatus?.toLowerCase()?.includes('pending') && isPsAdmin && (
										<>
											<Row className="mb-2">
												<Col xs={6}>
													<Row>
														<Col>
															<OverlayTrigger
																overlay={
																	<Tooltip id="demo-type-popup">
																		Select the discount type you would like to
																		apply to this order.
																		<br />
																		Default Dealer 70 is the original 70% off
																		MSRP.
																		<br />
																		Cash Override allows you to directly set the
																		invoice amount.
																		<br />
																		Percentage discount allows you to select a
																		percentage off of the original MSRP.
																		<br />
																		<strong>
																			Reject Demo declines the demo request -
																			double heads up - the rejection reason
																			is sent to the customer!
																		</strong>
																	</Tooltip>
																}
															>
																<h6>
																	Demo Type&nbsp;
																	<FontAwesomeIcon
																		icon={faInfoCircle}
																		className={`text-${quoteType}`}
																	/>
																</h6>
															</OverlayTrigger>
														</Col>
													</Row>
													<Row>
														<Col>
															<select
																className="w-100"
																onChange={(e) => setReviewType(e.target.value)}
																value={reviewType}
															>
																{approvalTypeOptions.map((atp) => (
																	<option key={atp.value} value={atp.value}>
																		{atp.display}
																	</option>
																))}
															</select>
														</Col>
													</Row>
												</Col>
												{reviewType !== approvalTypes.REJECT_DEMO && (
													<Col xs={6}>
														<Button
															fullWidth
															color={freeShipping ? 'green' : 'gray'}
															onClick={() => changeShipping(!freeShipping)}
															radioButton
														>
															Free Shipping&nbsp;
															<FontAwesomeIcon
																icon={freeShipping ? faCheck : faTimes}
															/>
														</Button>
													</Col>
												)}
											</Row>
											{approvalValueNeeded && (
												<p>
													<input
														style={{
															maxWidth: '60%',
														}}
														onChange={(e) => setInputValue(Number(e.target.value))}
														value={inputValue}
													/>
													{reviewType !== approvalTypes.CASH_OVERRIDE ? <>%</> : null}
												</p>
											)}
											{reviewType === approvalTypes.REJECT_DEMO && (
												<Row>
													<Col xs={12}>
														<OverlayTrigger
															overlay={
																<Tooltip id="status-check">
																	<strong>Heads up!</strong>
																	This is front facing - the customer will receive
																	an email with this explanation.
																</Tooltip>
															}
														>
															<>
																Rejection Reason &nbsp;
																<FontAwesomeIcon
																	icon={faInfoCircle}
																	className={`text-${quoteType}`}
																/>
															</>
														</OverlayTrigger>
													</Col>
													<Col xs={12}>
														<TextArea
															key="demo-notes"
															wrapperStyle={{
																alignSelf: 'center',
															}}
															style={{
																resize: 'none',
																minHeight: '7.5em',
																width: '100%',
															}}
															disabled={false}
															defaultValue={rejectionReason}
															onChange={(newValue) => setRejectionReason(newValue)}
															maxLength={2000}
														/>
													</Col>
												</Row>
											)}
										</>
									)}
								</Col>
								{isPsAdmin ? (
									<Col xs={12} className="mb-4">
										<Accordion>
											<Accordion.Item eventKey="0">
												<Accordion.Header>Previous Demo Quotes</Accordion.Header>
												<Accordion.Body>
													{previousDemoQuotes.demo_quotes.length > 0 ? (
														<table
															style={{
																overflowY: 'auto',
																width: '100%',
															}}
															className="clickable-table"
															cellSpacing="0"
														>
															<tbody>
																<tr className="bold-row">
																	<th>Quote Number</th>
																	<th>Date</th>
																</tr>
																{prevQuoteRows}
															</tbody>
														</table>
													) : (
														<>No previous demo quotes found.</>
													)}
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</Col>
								) : null}
							</Row>
							<Row>
								<Col className="col-6 text-start">
									<Button color="gray" onClick={closeMain}>
										Close
									</Button>
								</Col>
								{reviewStatus?.toLowerCase()?.includes('pending') && isPsAdmin && (
									<Col className="col-6 text-end">
										<Button
											color={quoteType}
											loading={submitting}
											onClick={handleSubmitReviewClick}
										>
											Submit Review
										</Button>
									</Col>
								)}
								{reviewStatus?.toLowerCase()?.includes('approved') && !isOrder && (
									<Col className="col-3 text-end">
										{placeOrderButton}
									</Col>
								)}
							</Row>
						</Container>
					</Popup>
				</>
			) : (
				<Popup
					open={confirmOpen}
					onClose={closeConfirm}
					className="mobile-modal"
					onOpen={() => {
						throw new Error('Demo Review clicked on errored quote');
					}}
				>
					<Container className="local-bootstrap">
						<Row>
							<Col>
								<h3>There was an issue fetching data.</h3>
							</Col>
						</Row>
						<Row>
							<Col>
								Please reach out to PowerShades Customer Service for assistance on placing this
								order.
							</Col>
						</Row>
						<Row className="align-text-bottom">
							<Col className="text-end">
								<Button onClick={closeConfirm} color={quoteType}>
									Close
								</Button>
							</Col>
						</Row>
					</Container>
				</Popup>
			)}
			<Button color={quoteType} fluid fullWidth onClick={mainButtonClicked}>
				{buttonText}
			</Button>
			
			<DiscountReasonModal
				defaultReason={quote?.discount_reason ?? ''}
				open={showDiscountModal}
				onCancel={handleDiscountModalCancel}
				onSubmit={handleDiscountModalSubmit}
				quoteType={quoteType}
			/>
		</div>
	);
};

export default DemoReview;
